import React from 'react'
import { Image } from '@/atoms/Image'
import { Placeholder } from '@/atoms/Placeholder'
import { CaptionMD, LabelSM } from '@/atoms/Text'
import { paths } from '@/constants'
import { LandscapeRowCollection } from '@/molecules/LandscapeRowCollection'
import { RecommendedUpNextContent } from '@/services/RecommendationService'
import { getCloudinaryImageUrl } from '@/utils/Cloudinary'
import { Translate, TranslateFunction } from '@/utils/translate/translate-client'
import { EndOfAssetRecommendation } from '@/views/WatchEpisodeView/EpisodeOverlay/EndOfAssetRecommendation'

interface EndOfAssetContentRecommendationProps {
  t: TranslateFunction
  projectName?: string
  recommendedUpNext: RecommendedUpNextContent
  loading?: boolean
  handleRecommendationClick: (slug?: string | null) => void
  handleDiscoverMoreClick?: () => void
}

export const EndOfAssetContentRecommendation: React.FC<EndOfAssetContentRecommendationProps> = ({
  t,
  projectName,
  recommendedUpNext,
  loading = false,
  handleRecommendationClick,
  handleDiscoverMoreClick,
}) => {
  return (
    <div className="mx-4 mt-8 lg:mx-0 lg:mt-20">
      <CaptionMD className="lg:photon-paragraph-md mb-2" weight="bold">
        <Translate t={t} i18nKey="showsLikeProjectYouWillLove" values={{ projectName }}>
          Shows like <i>{{ projectName }}</i> we think you&apos;ll love
        </Translate>
      </CaptionMD>
      {loading ? (
        <LandscapeRowCollection slidesToScroll={6} slidesToShow={6}>
          {[...Array(3)].map((_, i) => (
            <div className="pr-4" key={`placeholder-${i}`}>
              <Placeholder className="aspect-h-9 aspect-w-16 mb-2 rounded-xl" />
            </div>
          ))}
        </LandscapeRowCollection>
      ) : (
        recommendedUpNext &&
        recommendedUpNext?.length &&
        recommendedUpNext.length > 0 && (
          <LandscapeRowCollection slidesToScroll={6} slidesToShow={6}>
            {recommendedUpNext?.map((recommendation) => {
              if (!recommendation || !recommendation?.title?.image?.cloudinaryPath) return null
              return (
                <EndOfAssetRecommendation
                  key={recommendation.id}
                  recommendation={recommendation}
                  handleRecommendationClick={handleRecommendationClick}
                />
              )
            })}
            <a className="pb-2 pr-4" href={paths.watch.index} onClick={handleDiscoverMoreClick}>
              <div className="relative inline-block h-fit duration-[400ms] ease-in-out hover:z-10 md:hover:scale-[1.05]">
                <Image
                  aria-label={'Angel Studios Watch'}
                  alt={'Angel Studios Watch'}
                  src={getCloudinaryImageUrl({
                    path: '/v1738101991/angel-studios/backgrounds/cta-bg-1.webp',
                    width: 380,
                  })}
                  height={253}
                  width={450}
                  className="rounded-xl bg-black"
                />
                <LabelSM className="lg:photon-label-md absolute inset-0 flex items-center justify-center text-white">
                  {t('discoverMore', 'Discover More')}
                </LabelSM>
              </div>
            </a>
          </LandscapeRowCollection>
        )
      )}
    </div>
  )
}
